import { render } from "./SavedListsPanel.vue?vue&type=template&id=37cbf6ab"
import script from "./SavedListsPanel.vue?vue&type=script&lang=js"
export * from "./SavedListsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__